import type { JiraSpaRoute, Query, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import {
	MENU_ID_COMMUNICATION,
	MENU_ID_COMMUNICATIONS_STAKEHOLDERS,
} from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'communications-stakeholder-groups',
	'communications-stakeholders',
]);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName = routeContext.route.name;
	const { query } = routeContext;
	const path: string[] = [MENU_ID_COMMUNICATION];
	return convertRouteToPath({ routeName, query, path });
}

function convertNew(args: { routeName: RouteName; query: Query }): SelectedPath {
	const { routeName, query } = args;
	const path: string[] = [MENU_ID_COMMUNICATION];
	return convertRouteToPath({ routeName, query, path });
}

function convertRouteToPath(args: {
	routeName: RouteName;
	query: Query;
	path: string[];
}): SelectedPath {
	const { routeName, path } = args;
	switch (routeName) {
		case 'communications-stakeholder-groups':
			path.push(MENU_ID_COMMUNICATIONS_STAKEHOLDERS);
			break;
		case 'communications-stakeholders':
			path.push(MENU_ID_COMMUNICATIONS_STAKEHOLDERS);
			break;

		default: {
			break;
		}
	}

	return path;
}

export const communicationsConverter = { routes, convert, convertNew };
